import React from "react";
import LayerGroup from "../../../../types/LayerGroup";
import LayerLegend from "../sharedComponents/LayerLegend";
import LegendRow from "../sharedComponents/LegendRow";

class CityBoundariesLegend extends React.PureComponent<{}, {}> {
  render() {
    return (
      <LayerLegend
        layerGroup={LayerGroup.CityBoundaries}
        classes="city-boundaries"
        legendRows={[
          <LegendRow
            color="#D27CDF"
            text="City Boundaries"
          />
        ]}
      />
    );
  }
}

export default CityBoundariesLegend;